<div class="popover-content-wrapper" [class.editing]="isEditing()">
  <div class="popover-header">
    @if (isPinned()) {
      <dojo-icon-button [icon]="'xmark'" [size]="'xs'" (click)="onClose()" />
    }
  </div>

  <div class="popover-body">
    <dojo-tiptap-editor-wrapper
      class="popover-editor"
      [class.readonly]="!isEditing()"
      [valueControl]="editorControl"
      [editable]="isEditing()"
      [contentPadding]="'1em'"
      [outputFormat]="TiptapEditorOutputFormat.Json"
      [editorOptions]="editorOptions()"
      [slashMenuItems]="slashMenuItems()"
      [smartLinkConfig]="reactSmartLinkConfig()"
    />

    @if (isEditing()) {
      <dojo-smart-link-input
        [formCtrl]="linkUrlControl"
        [label]="'examdojo.popover.link_url_label' | transloco"
        [placeholder]="'examdojo.popover.link_url_placeholder' | transloco"
      />
    } @else if (linkUrl()) {
      @if (isExternalLink()) {
        <a [href]="linkUrl()" target="_blank" rel="noopener noreferrer" (click)="onClose()">
          <ng-container *ngTemplateOutlet="learnMoreButton" />
        </a>
      } @else if (hasResolver) {
        <button type="button" class="w-full" (click)="onResolveLink()">
          <ng-container *ngTemplateOutlet="learnMoreButton" />
        </button>
      } @else {
        <a [routerLink]="linkUrl()" (click)="onClose()">
          <ng-container *ngTemplateOutlet="learnMoreButton" />
        </a>
      }
    }
  </div>
</div>

<ng-template #learnMoreButton>
  <dojo-button class="w-full">
    {{ 'examdojo.learn_more' | transloco }}
  </dojo-button>
</ng-template>
